
<template>
  <div class="loader d-flex justify-content-center">
    <img 
      src="@/assets/images/loaders/loader.svg" 
      alt="" 
      :width="width" 
    >
  </div>
</template>

<script>
export default {
  name: 'GeneralLoader',

  props: {
    isLoading: {
      type: [Boolean, null],
      required: false
    },

    message: {
      type: String,
      required: false
    },

    size: {
      type: String,
      default: '100'
    }
  },

  computed: {
    width() {
      return `${this.size}px`
    }
  }
}
</script>
